import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { TixSelector } from '@tix-ticketing/ui-components';
import { bindToggle, usePopupState } from 'material-ui-popup-state/hooks';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { QuantitySelector } from 'components/common/quantity-selector/quantity-selector';
import { EventFilterButton } from 'components/events-list/event-filter-button';
export const EventsPaginatedTicketsFilterSelector = ({
  ticketCount,
  setTicketCount
}: {
  ticketCount: number | null;
  setTicketCount: (ticketCount: number | null) => void;
}) => {
  const ticketsState = usePopupState({
    variant: 'popper',
    popupId: 'ticketsFilterSelector'
  });

  // Opening the filter means "only dates with ticket availability", so the
  // filter activates at one ticket. The decrease button stops at that minimum,
  // and the filter is removed via the button's clear (X) instead.
  useEffect(() => {
    if (ticketsState.isOpen && ticketCount === null) {
      setTicketCount(1);
    }
  }, [ticketsState.isOpen, ticketCount, setTicketCount]);
  return <TixSelector triggerElement={<EventFilterButton active={ticketsState.isOpen} clearable={ticketCount !== null} onClear={() => {
    ticketsState.close();
    setTicketCount(null);
  }} label={ticketCount !== null ? <FormattedMessage id="common.xTickets" defaultMessage={[{
    "type": 6,
    "value": "tickets",
    "options": {
      "one": {
        "value": [{
          "type": 7
        }, {
          "type": 0,
          "value": " ticket"
        }]
      },
      "other": {
        "value": [{
          "type": 7
        }, {
          "type": 0,
          "value": " tickets"
        }]
      }
    },
    "offset": 0,
    "pluralType": "cardinal"
  }]} values={{
    tickets: ticketCount
  }} /> : <FormattedMessage id="common.tickets" defaultMessage={[{
    "type": 0,
    "value": "Tickets"
  }]} />} {...bindToggle(ticketsState)} />} open={ticketsState.isOpen} onClose={() => ticketsState.close()} localeState={ticketsState} hideCloseButton popperPlacement="bottom-start" popperMaxWidth={225}>
      <Stack sx={{
      alignItems: 'center',
      gap: 1
    }}>
        <Typography variant="h6">
          <FormattedMessage id="event.filter.howManyTickets" defaultMessage={[{
          "type": 0,
          "value": "How many tickets?"
        }]} />
        </Typography>
        <Typography variant="body2" align="center" sx={{
        mb: 1.5
      }}>
          <FormattedMessage id="event.filter.ticketAvailabilityInfo" defaultMessage={[{
          "type": 0,
          "value": "Only show dates with ticket availability"
        }]} />
        </Typography>
        <QuantitySelector value={ticketCount ?? 1} minimum={1} onChange={value => setTicketCount(value)} />
      </Stack>
    </TixSelector>;
};